import _ from 'lodash'

jQuery(function($) {
  var pos = 0;

  $(window).on('scroll', _.throttle(function() {
    if(window.matchMedia('(min-width: 992px)').matches) {
      if(window.scrollY >= $('.navbar-static-top').height() && $(this).scrollTop() < pos) {
        $('.fixed-nav').addClass('fixed-nav--active')
      }else{
        $('.fixed-nav').removeClass('fixed-nav--active')
      }
      pos = $(this).scrollTop();
    }
  }, 200))
});